import { useEffect, useRef, useState } from "react";
import { useCurrency } from "@/contexts/CurrencyContext";
import { ChevronDown, DollarSign } from "lucide-react";

export default function CurrencySwitcher() {
  const { code, setCode, currencies } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);
  return (
    <div className="relative" ref={ref}>
      <button onClick={()=>setOpen(v=>!v)}
        className="inline-flex items-center gap-1 px-2 py-1.5 rounded-full hover:bg-[#F5F5F5] text-xs font-medium text-[#454545]"
        data-testid="currency-switcher" aria-haspopup="menu" aria-expanded={open}>
        <DollarSign size={12}/><span>{code}</span><ChevronDown size={11} className={open ? "rotate-180" : ""}/>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-white rounded-2xl shadow-lg border border-[#E8E8E8] overflow-hidden z-40" data-testid="currency-menu">
          {currencies.map(c => (
            <button key={c.code}
              onClick={()=>{ setCode(c.code); setOpen(false); }}
              data-testid={`currency-${c.code}`}
              className={`w-full flex items-center justify-between gap-2 px-3 py-2.5 text-sm text-left hover:bg-[#F5F5F5] ${code === c.code ? "bg-[#F5F5F5] font-medium" : ""}`}>
              <span>{c.symbol} {c.code}</span>
              <span className="text-xs text-[#8C8C8C]">{c.label}</span>
            </button>
          ))}
          <p className="px-3 py-2 text-[10px] text-[#8C8C8C] border-t border-[#E8E8E8]">Display only · charged in seller&apos;s currency at checkout.</p>
        </div>
      )}
    </div>
  );
}
